// eslint-disable-next-line import/no-amd
define([
    'jquery',
    'underscore',
    'backbone',
    '../models/InterfaceParameterCollection',
    '../../app/views/AlertView',
    '../templates/config_view.template',
    '../templates/config_parameter.template'
], ($, _, Backbone, Collection, AlertView, html, params) => {
    const View = Backbone.View.extend({
        initialize(options) {
            this.options = options || [];
        },
        render() {
            const view = this;
            const onExec = _.isUndefined(view.options.onExec) ? false : view.options.onExec;
            view.collection = new Collection();
            view.collection.fetch({
                data: { interface_id: view.model.get('interface_id') },
                success() {
                    let compiled = _.template(html)({
                        $,
                        col: view.collection,
                        title: $._('interface.config.title'),
                        cancel: $._('dialog.cancel'),
                        ok: onExec ? $._('interface.start') : $._('interface.config.save')
                    });
                    compiled = $(compiled);
                    view.collection.each(item => {
                        item.set('onExec', onExec);
                        const compiledParams = _.template(params)({ item });
                        compiled.find('.params').append(compiledParams);
                    });
                    compiled.find('.input').uiselectfield('init');
                    compiled.find('.input').uicheckbox('init');
                    $.modal(
                        compiled,
                        {
                            overlayId: 'simplemodal-overlay',
                            minWidth: '680px',
                            maxWidth: '680px',
                            containerId: 'modalWidget',
                            persist: true,
                            overlayClose: false,
                            autoResize: true,
                            onShow() {
                                view.setElement('.modalWidget');
                                view.$('input.datepicker').datepicker({
                                    changeMonth: true,
                                    changeYear: true
                                });
                                // view.$("form").validationEngine();
                            },
                            onClose() {
                                $.modal.close();
                                view.$el.validationEngine('hideAll');
                            }
                        }
                    );
                }
            });
        },
        events: {
            'click .modalYes': 'btSave'
        },
        btSave() {
            const view = this;
            view.model.setForm(view.$('form'));
            if (view.options.onExec) {
                this.model.set('onExec', true);
            }
            this.model.save(formMessage => {
                if (formMessage.showErrors()) {
                    $.modal.close();
                    if (_.isFunction(view.options.success)) {
                        view.options.success();
                    } else {
                        // Bestaetigungsfenster
                        AlertView.show({
                            message: $._('interface.config.success'),
                            title: $._('interface.config.success.title'),
                        });
                    }
                }
            });
            return false;
        }
    });
    return View;
});



// WEBPACK FOOTER //
// ./src/components/interface/views/ConfigView.js